import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ExpandableHtml } from '@bibliocommons/expandable';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

import './BibDescription.scss';

const { composeReadMoreEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleReadMoreClick(expanded) {
  sendAnalyticsEvents(
    composeReadMoreEvent({
      expanded,
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.TRANSACT_DESCRIPTION
    })
  );
}

export class BibDescription extends React.PureComponent {
  render() {
    const { catalogBib } = this.props;
    const htmlText = catalogBib.getIn(['brief', 'description'], '');
    if (!htmlText) return null;

    return (
      <div className="cp-bib-description">
        <ExpandableHtml
          truncateCount={325}
          htmlText={htmlText}
          expandLinkHref={`#read-more-bib-${catalogBib.get('metadataId')}`}
          textKey="about_the_title"
          handleToggle={handleReadMoreClick}
        />
      </div>
    );
  }
}

BibDescription.propTypes = {
  catalogBib: catalogBibShape.isRequired
};

export default BibDescription;
